import { render } from "./AccessTemplate.vue?vue&type=template&id=516426da&scoped=true&ts=true"
import script from "./AccessTemplate.vue?vue&type=script&lang=ts"
export * from "./AccessTemplate.vue?vue&type=script&lang=ts"

import "./AccessTemplate.vue?vue&type=style&index=0&id=516426da&lang=scss&scoped=true"

import exportComponent from "/Users/hirosuke-pi/projects/vr-jmof-front-2020/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-516426da"]])

export default __exports__